import "./toastr.css"
const Toastr = ({ message, type, onClose }) => {
    return (
      <div className={`toastr toastr-${type}`}>
        {message}
      </div>
    );
  };
  export default Toastr;